import type { User } from '@models/User';

export const hasFlag = (user: User, flag: string) => !!user?.tenant?.features?.includes(flag);
